import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import 'common/sceneBackNav.scss';
import '../Questionnaire.scss';

const sceneBackNavLayout =
  'scene-back-nav scene-back-nav--inverse absolute left-2-ns left-1 top-0';

class FormQuestion extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    link: PropTypes.string,
    onBack: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    link: '/my_tasks',
    onBack: undefined,
  };

  render() {
    const { title, children, link, onBack, location } = this.props;

    return (
      <div
        data-testid="form-question"
        className="overflow-auto relative flex-auto flex flex-column items-center justify-center"
      >
        <div className="f4 pa3 tc bg-primary white w-100">
          <h2 className="f4 white ma0 lh-copy tc pl6 pr5">
            <span
              id="questionnaire-task-title"
              className="db white questionnaire-task-title"
              tabIndex={0}
              role="heading"
              aria-level={1}
            >
              {title}
            </span>
          </h2>
        </div>
        {children}
        {onBack ? (
          <button
            type="button"
            className={`${sceneBackNavLayout} bn pa0 pointer`}
            onClick={onBack}
            aria-label="Back"
          >
            <i
              className="fas fa-arrow-left scene-back-nav__icon"
              aria-hidden="true"
            />
          </button>
        ) : (
          location.pathname.startsWith('/my_tasks') && (
            <Link
              className={`${sceneBackNavLayout} bn pa0 pointer`}
              to={link}
              aria-label="Back"
            >
              <i
                className="fas fa-arrow-left scene-back-nav__icon"
                aria-hidden="true"
              />
            </Link>
          )
        )}
      </div>
    );
  }
}

export default withRouter(FormQuestion);
